import { BM_JOURNEYS, CHECK_AUTH_REDIRECTION } from '@auth-oauth2/constants'
import { COUNTRIES } from '@config/constants'
import { dynamicImport } from '@core/helpers'
import minimalLayout from '@core/layouts/minimal.vue'
import { ROUTES } from '@router'

const buybackEligibleCountries = [COUNTRIES.FR, COUNTRIES.DE, COUNTRIES.US]

export const buybackRefurbisherMinimalLayoutRoutes = ({ country }) => {
  if (buybackEligibleCountries.includes(country)) {
    return [
      {
        path: '/bo_merchant/buyback/orders/:id/conversation',
        component: minimalLayout,
        props: {
          fullWidth: true,
        },
        meta: {
          auth: {
            required: true,
            redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
          },
          seller: {
            required: true,
            redirection: { name: ROUTES.BO_MERCHANT.LOGIN },
          },
        },
        children: [
          {
            name: ROUTES.BUYBACK.REFURBISHER.CONVERSATION,
            path: '',
            component: () =>
              dynamicImport(
                import('@buyback/refurbisher/orders/pages/OrderConversation'),
              ),
          },
        ],
      },
    ]
  }

  return []
}

export const buybackAdminMinimalLayoutRoutes = () => {
  return [
    {
      path: '/bo_admin/buyback/orders/:id',
      component: () =>
        dynamicImport(
          import('@admin-tools/shared/components/layouts/Base.vue'),
        ),
      meta: {
        auth: {
          required: true,
          redirection: {
            name: ROUTES.ADMIN_TOOLS.HOME,
          },
        },
        staff: {
          required: true,
        },
      },
      children: [
        {
          name: ROUTES.BUYBACK.ADMIN.ORDER,
          path: '',
          component: () =>
            dynamicImport(import('@buyback/staff/orders/pages/Order')),
        },
      ],
    },
  ]
}

export const buybackCustomerMinimalLayoutRoutes = ({ country }) => {
  if (buybackEligibleCountries.includes(country)) {
    return [
      {
        path: 'dashboard/sales/:id/conversation',
        component: minimalLayout,
        props: {
          fullWidth: true,
        },
        meta: {
          auth: {
            required: true,
            // CHECK_AUTH_REDIRECTION only works in an array redirection
            redirection: [
              CHECK_AUTH_REDIRECTION,
              // eslint-disable-next-line camelcase
              { bm_journey: BM_JOURNEYS.BUYBACK },
            ],
          },
        },
        children: [
          {
            name: ROUTES.BUYBACK.CUSTOMER.DASHBOARD.CONVERSATION,
            path: '',
            component: () =>
              dynamicImport(
                import('@buyback/customer/dashboard/pages/SaleConversation'),
              ),
          },
        ],
      },
    ]
  }

  return []
}
